import React from 'react';

import './styles/styles.css';
import './styles/responsive.css'

import Routes from './routes/Routes';


function App() {

  return (
    <Routes/>
  );
}

export default App;
